import React, { useEffect, useState } from "react";
import { Button, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { Field, Formik } from "formik";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import reset from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import CoveredEntity from "components/CoveredEntity";
import useContextService from "hooks/useContextService";
import Accmulator from "components/Accmulator";
import ReactSelect from 'react-select';
import useAxios from "hooks/useAxios";
import { Option } from 'components/Options';

let coveredEntitiesData = [];
let accumulationData = [];
let accumulator =[];
let coveredEntityError = "Covered Entity is a required field";
let accumulationError = "Accumulator is a required field";
const SearchContainerNDCs = (props) => {
  const {
    toggleSide,
    collapseSider,
    orgId,
    onSearch,
    resetData,
    key,
    setLoading,
    reset,
    setStoredDate
  } = props;
  const {
    states: { crosswalkNdc },
    setStates,
    resetStates,
  } = useContextService();
  const API = useAxios();
  const [hasACCSelected, setACCSelected] = useState(true);
  const [hasCESelected, setCESelected] = useState(true);
  //const [loading, setLoading] = useState(false);
  const [isSubmited, serIsSubmitted] = useState(false);
  const [selectedCEOption, setCEOptionSelected] = useState({
    optionCESelected: "-1",
  });
  const [selectedACCOption, setOptionACCSelected] = useState({
    optionACCSelected: "-1",
  });
  const updateStates = (crosswalkNdc) => {
    setStates("crosswalkNdc", crosswalkNdc);
  };
  const { crosswalkNdcsearch, searchTerms } = crosswalkNdc;
  let {
    coveredEntityIDs,
    accumulationIDs,

  } = searchTerms;
  useEffect(() => {
    setCESelected(true);
    setACCSelected(true);
    coveredEntitiesData = [];
    accumulationData = [];
    crosswalkNdc.searchTerms.coveredEntityIDs = [];
    crosswalkNdc.searchTerms.accumulationIDs = {}
    crosswalkNdc.accumulations = [];
    updateStates(crosswalkNdc);
    setCEOptionSelected({ optionCESelected: '-1' });
    setOptionACCSelected({ optionACCSelected: '-1' });
    serIsSubmitted(false);
    fetchCoveredEntities();
  }, [orgId, key, reset]);

  const fetchCoveredEntities = async () => {
    debugger;
    //let { organizationID } = orgId;
    if (typeof orgId !== "undefined" && orgId !== null) {
      coveredEntitiesData = [];
      crosswalkNdc.searchTerms.coveredEntityIDs = [];
      updateStates(crosswalkNdc);

      let selectedOrgId = orgId.organizationID;

      setLoading(true);
      try {
        const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
          hasDefaultURL: true,
        });

        if (data) {
          for (var x in data) {
            coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
          }
          crosswalkNdc.coveredEntities = data;

          if (coveredEntitiesData.length == 1) {
            var ceData = [];
            ceData.push(coveredEntitiesData[0])
            crosswalkNdc.searchTerms.coveredEntityIDs = ceData;
            window.selectedCoveredEntittyId = ceData;
          }
          if (window.selectedCoveredEntittyId.length > 0) {
            crosswalkNdc.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
          }
          updateStates(crosswalkNdc);
          if (crosswalkNdc.searchTerms.coveredEntityIDs) {

            var ceSelected = [];
            ceSelected.optionCESelected = [];
            for (var x in crosswalkNdc.searchTerms
              .coveredEntityIDs) {
              ceSelected.optionCESelected.push(
                crosswalkNdc.searchTerms.coveredEntityIDs[x]
              );
            }
            setCEOptionSelected(ceSelected);
            let ceIds = crosswalkNdc.searchTerms.coveredEntityIDs.map(item => item["value"]);
            fetchAccumulatorName(ceIds);
          }
          setLoading(false);
        }
        setLoading(false);
      }
      catch (err) {
        setLoading(false);
      }
    }

  };
  const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
    let selected = [selectedces == null ? [] : selectedces]

    if (selected) {
      window.selectedCoveredEntittyId = selected;
      window.selectedAccumulatorId = [];
      accumulationData = [];
      // setSelectedNdc('');
      crosswalkNdc.searchTerms.accumulationIDs = {};
      setCESelected(true);
      setCEOptionSelected({
        optionCESelected: selectedces
      });
      let val = selected.value;
      crosswalkNdc.coveredEntities = selected;
      // setFieldValue('coveredEntityIDs', selected);
      crosswalkNdc.searchTerms.coveredEntityIDs = selected;
      if (Array.isArray(crosswalkNdc.searchTerms.coveredEntityIDs)) {
        accumulationIDs = {};
        crosswalkNdc.searchTerms.accumulationIDs = {};
      }
      let ceIds = crosswalkNdc.searchTerms.coveredEntityIDs.map(item => item["value"]);
      crosswalkNdc.searchTerms.coveredEntityIDs = ceIds;
      updateStates(crosswalkNdc);
      fetchAccumulatorName(ceIds);
      setOptionACCSelected({ optionACCSelected: '-1' });
    }
    else {
      // setFieldValue('coveredEntityIDs', {});
      accumulationData = [];
      crosswalkNdc.coveredEntities = [];
      crosswalkNdc.searchTerms.coveredEntityIDs = {};
      crosswalkNdc.searchTerms.accumulationIDs = {};
      setCESelected(false);
      setACCSelected(false);
    }
    updateStates(crosswalkNdc);
  };
  const fetchAccumulatorName = async (coveredEntityIDs) => {

    if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
      try {
        accumulationData = [];
        const payload = [];
        payload.AccumulatorEntityList = [coveredEntityIDs[0]];
        let AccumulatorEntityList = [payload.AccumulatorEntityList]
        const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
          {
            hasDefaultURL: true,
          }
        );
        if (result) {
          // let accumulator = []
          accumulator = result.data;
          for (var x in accumulator) {
            accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
          }

          if (accumulationData.length == 1) {
            handleAccumulatorname(accumulationData[0]);

          }
          //    else if (window.selectedAccumulatorId.length > 0) {
          //     crosswalkNdc.searchTerms.accumulationIDs =
          //       window.selectedAccumulatorId;
          //       handleAccumulatorname(window.selectedAccumulatorId[0]);
          //   }

          crosswalkNdc.accumulations = result.data;
          updateStates(crosswalkNdc);
          // if (accumulationIDs.length > 0) {
          //     var accumulatorSelected = {};
          //     accumulatorSelected.optionACCSelected = [];
          //     for (var x in accumulationIDs) {
          //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
          //     }
          //     setOptionACCSelected({ accumulatorSelected});
          // }
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };
  const handleAccumulatorname = (selectedacs, setFieldValue, ac) => {

    let selected = [selectedacs == null ? [] : selectedacs]
    window.selectedAccumulatorId = selected;
    if (selected) {
      setACCSelected(true);
      setOptionACCSelected({
        optionACCSelected: selected
      })
      //   let val = selected.value;
      //   setFieldValue('accumulatorID', val);
      //   setFieldValue('accumulationIDs', selected);
       const match= accumulator.find(items => items.accumulatorID ===selected[0].value)
      if(match?.cEliveDate){
        setStoredDate(match.cEliveDate);
      }
      crosswalkNdc.searchTerms.accumulationIDs=selected;
      handleSubmit();
    }
    else {
      setACCSelected(true);
      //   setFieldValue('accumulationIDs', {});
      accumulationData = [];
      crosswalkNdc.coveredEntities = [];
      crosswalkNdc.searchTerms.accumulationIDs = {};
      crosswalkNdc.searchTerms.coveredEntityIDs = {};
      setCESelected(false);
    }
    updateStates(crosswalkNdc);
  };

  const handleSubmit = async () => {
    debugger;
    let values = {};
    serIsSubmitted(true);
    // const { setSubmitting } = actions;
    let acIDs = [];
    let ceIDs = [];
    for (var x in searchTerms.accumulationIDs) {
      var rw = searchTerms.accumulationIDs[x];
      acIDs.push(rw.value);
    }
    for (var x in searchTerms.coveredEntityIDs) {
      var rw = searchTerms.coveredEntityIDs[x];
      ceIDs.push(rw.value);

    }

    if (ceIDs.length > 0 && acIDs.length == 0) {
      setACCSelected(false);
      return true;
    }
    if (ceIDs.length == 0 && acIDs.length == 0) {
      setCESelected(false);
      setACCSelected(false);
      return true;
    }
    if (acIDs > [0]) values.accumulationIDs = acIDs[0];
    crosswalkNdc.crosswalkNdcsearch.currentPage = 1;
    crosswalkNdc.crosswalkNdcsearch.filters = [];
    updateStates(crosswalkNdc);
    await onSearch(values);
    // setSubmitting(false);
  };
  const handleReset = async () => {
    debugger;
    serIsSubmitted(false);
    setCESelected(true);
    setACCSelected(true);
    accumulationData = [];
    window.selectedCoveredEntittyId = "";
    window.selectedAccumulatorId = "";
    setCEOptionSelected({ optionCESelected: "-1" });
    setOptionACCSelected({ optionACCSelected: "-1" });
    crosswalkNdc.searchTerms.coveredEntityIDs = {};
    crosswalkNdc.searchTerms.mappingStatus = "all";
    crosswalkNdc.searchTerms.accumulationIDs = {};
    crosswalkNdc.crosswalkNdcsearch.AccumulatorID = 0;
    updateStates(crosswalkNdc);
    //resetStates("crosswalkNdc");
    await resetData()
  }
  return (
    <div>
      {/* {Loading&&<Loader opacity={0.01}color='black'/>}  */}
      <Formik
        initialValues={searchTerms}
        onSubmit={handleSubmit}
        // validationSchema={validationSchema}
        enableReinitialize={true}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
          return (
            <div hidden={collapseSider}>
              <div>
                <Row sm={5} className="d-flex" style={{}}>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="coveredentity">
                        Covered Entity
                      </Label>

                      <ReactSelect
                        name="coveredentity"
                        id="coveredentity"
                        options={coveredEntitiesData}
                        // isMulti
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        // isClearable={true}
                        isSearchable="true"
                        onChange={(value, cp) =>
                          handleCoverdEntityChange(
                            value,
                            setFieldValue,
                            cp
                          )
                        }
                        value={selectedCEOption.optionCESelected}
                        className="claim_info required"
                        components={{
                          Option,
                        }}
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                            ...provided,
                            display: "flex",
                            alignItems: "flex-start",
                          }),
                        }}
                      />
                      {!hasCESelected ? (
                        <div className="text-danger f-12 position-absolute">
                          {coveredEntityError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="accumulator">Accumulator</Label>
                      <ReactSelect
                        name="accumulatorID"
                        id="accumulationIDs"
                        options={accumulationData}
                        // isMulti
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        isDisabled={accumulationData.length == 1}
                        //isClearable={true}
                        components={{
                          Option,
                        }}
                        value={selectedACCOption.optionACCSelected}
                        isSearchable="true"
                        onChange={(value, ac) =>
                          handleAccumulatorname(
                            value,
                            setFieldValue,
                            ac
                          )
                        }
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                            ...provided,
                            display: "flex",
                            alignItems: "flex-start",
                          }),
                        }}
                      />
                      {(!hasACCSelected && isSubmited) ||
                        (hasCESelected &&
                          isSubmited &&
                          selectedACCOption.optionACCSelected ==
                          "-1") ? (
                        <div className="text-danger f-12 position-absolute">
                          {accumulationError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div hidden={""}>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Col md="auto" className="">
                    <Label>{""}</Label>
                    <Button
                      color="primary"
                      className="search"
                      onClick={handleSubmit}
                    >
                      <span className="right_5">
                        <img src={search} alt="" />
                      </span>{" "}
                      Search
                    </Button>
                    <Button
                      color="primary"
                      className="reset"
                      onClick={handleReset}
                    >
                      <span className="right_5">
                        <img src={reset} alt="" />
                      </span>{" "}
                      Reset
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          );
        }}></Formik>
    </div>
  )

}

export default SearchContainerNDCs